
import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import { useStudent } from '@/features/student/useStudent';
import { useRoute, useRouter } from 'vue-router';
import { _ROUTER_NAME } from '@/enums';
import Multiselect from '@suadelabs/vue3-multiselect';
import PlanFutureSlideOver from '@/components/modules/reportTarget/PlanFutureSlideOver.vue';
import { useTutorial } from '@/features/tutorial/useTutorial';

export default defineComponent({
	name: 'CreateGoalsFuture',
	components: {
		PlanFutureSlideOver,
		Multiselect,
	},
	setup() {
		const id = ref('');
		const router = useRouter();
		const student: any = ref(null);
		const isSlideOpen = ref(true);
		const isUpdated = ref(false);
		const { isEditPlanTour, advanceSpotlight, activeSpotlight } =
			useTutorial();
		const tab = ref({
			label: '',
			value: '',
		} as any);
		const tabs = ref([
			{
				label: 'Mục tiêu mới',
				value: 'plans_report_detail__goal_create_current__create',
			},
			{
				label: 'Ngân hàng mục tiêu',
				value: 'plans_report_detail__goal_create_current__create_by_bank',
			},
			{
				label: 'Mục tiêu tạm dừng',
				value: 'plans_report_detail__goal_create_current__create_by_stop',
			},
			{
				label: 'Mục tiêu hoàn thành',
				value: 'plans_report_detail__goal_create_current__create_by_completed',
			},
		]);
		const route = useRoute();
		id.value = route.params.id ? route.params.id + '' : '';
		const { getStudent } = useStudent();

		watch(route, () => {
			const name = route?.name;
			tab.value = tabs.value.find((item) => item.value == name);
		});

		watch(tab, (value: { value: string }) => {
			if (value) {
				router.push({ name: value.value });
			}
		});

		onMounted(() => {
			const name = route?.name;
			tab.value = tabs.value.find((item) => item.value == name);

			isSlideOpen.value = window.screen.width >= 1024;

			window.scrollTo(0, 0);
		});

		async function fetchStudent() {
			const res = await getStudent(id.value);
			if (res?.data) {
				student.value = res?.data;
			}
		}

		fetchStudent();

		function back() {
			router.push(`/plans/${id.value}`);
		}

		function onSelectNewGoalTab() {
			if (
				isEditPlanTour.value &&
				activeSpotlight.value?.targetId === 'plan-tab-new'
			) {
				advanceSpotlight();
			}
		}

		const isCompleted = ref(true);

		function openKHDK() {
			isSlideOpen.value = true;
			isCompleted.value = true;
			isUpdated.value = false;
		}

		function openMTHT() {
			isSlideOpen.value = true;
			isCompleted.value = false;
			isUpdated.value = false;
		}

		function onUpdated() {
			isUpdated.value = true;
		}

		return {
			isUpdated,
			openKHDK,
			openMTHT,
			isCompleted,
			isSlideOpen,
			tab,
			tabs,
			student,
			routerName: computed(() => _ROUTER_NAME),
			back,
			onUpdated,
			onSelectNewGoalTab,
		};
	},
});
